import React from 'react';
import { Tree, TreeNode } from 'react-organizational-chart';

const Nodo = ({ cargo, nombre, sub, color }) => (
  <div style={{
    display: 'inline-block',
    background: 'white',
    border: `2px solid ${color || '#ddd'}`,
    borderRadius: '8px',
    padding: '8px 12px',
    minWidth: '120px',
    maxWidth: '155px',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
  }}>
    <div style={{
      fontSize: '0.65rem',
      fontWeight: '700',
      color: '#1a1a2e',
      textTransform: 'uppercase',
      letterSpacing: '0.03em',
      lineHeight: 1.4,
    }}>{cargo}</div>
    {nombre && (
      <div style={{ fontSize: '0.7rem', color: '#7c6ff7', marginTop: '4px' }}>
        {nombre}
      </div>
    )}
    {sub && (
      <ul style={{ listStyle: 'none', textAlign: 'left', marginTop: '6px', fontSize: '0.62rem', color: '#555', lineHeight: 1.7 }}>
        {sub.map((s, i) => <li key={i}>• {s}</li>)}
      </ul>
    )}
  </div>
);

function OrganigramaView() {
  return (
    <div className="seccion-container" style={{ maxWidth: '100%', overflowX: 'auto' }}>
      <h2 className="seccion-titulo-pag">🏢 Organigrama BellPro</h2>
      <div style={{ padding: '20px 0', minWidth: '900px' }}>
        <Tree
          lineWidth="2px"
          lineColor="#bbb"
          lineBorderRadius="6px"
          label={<Nodo cargo="Gerencia" color="#1a1a2e" />}
        >
          <TreeNode label={<Nodo cargo="Coordinador General" nombre="Lucas Dolade" color="#7c6ff7" />}>
            <TreeNode label={<Nodo cargo="Supervisión de Inspección" nombre="Nahuel Álvarez" color="#3b82f6" />}>
              <TreeNode label={<Nodo cargo="Jefe de Inspección de Obra" color="#3b82f6" />}>
                <TreeNode label={<Nodo cargo="Inspección de Obra TGN" color="#f97316" sub={['Inspección', 'Integridad', 'SHYMA', 'Terrenos', 'Insp. Terceros']} />} />
              </TreeNode>
            </TreeNode>
            <TreeNode label={<Nodo cargo="Responsable de Obra" nombre="Marcos Sabena" color="#3b82f6" />}>
              <TreeNode label={<Nodo cargo="Jefe de Obra" color="#3b82f6" />}>
                <TreeNode label={<Nodo cargo="ADM. Obra" color="#f97316" />} />
                <TreeNode label={<Nodo cargo="Tec. Seguridad" color="#f97316" />} />
                <TreeNode label={<Nodo cargo="Tec. Calidad" color="#f97316" />} />
                <TreeNode label={<Nodo cargo="Ayudantes y 3ros" color="#f97316" />} />
              </TreeNode>
            </TreeNode>
            <TreeNode label={<Nodo cargo="Mantenimiento de Plantas" nombre="Nicolas Zampelli" color="#3b82f6" />}>
              <TreeNode label={<Nodo cargo="ADM. Obra" color="#f97316" />} />
              <TreeNode label={<Nodo cargo="Tec. Seguridad" color="#f97316" />} />
              <TreeNode label={<Nodo cargo="Tec. Calidad" color="#f97316" />} />
            </TreeNode>
            <TreeNode label={<Nodo cargo="Administración de Campo" nombre="Christian Kaufmann" color="#3b82f6" />}>
              <TreeNode label={<Nodo cargo="Asistencia - Roster" nombre="Estela Aleman" color="#f97316" />} />
              <TreeNode label={<Nodo cargo="Equipos y Vehículos" nombre="Paola Salate" color="#f97316" />} />
              <TreeNode label={<Nodo cargo="Rendiciones y Viáticos" nombre="Lucas Moser" color="#f97316" />} />
              <TreeNode label={<Nodo cargo="Auditoría ISO" color="#f97316" />} />
            </TreeNode>
          </TreeNode>
          <TreeNode label={<Nodo cargo="Administración Contable" nombre="Base BsAs" color="#7c6ff7" />} />
        </Tree>
      </div>
    </div>
  );
}

export default OrganigramaView;